import { normalizeDateToMDY } from '@/core/utils/utils'

/** Fechas del proyecto: MM-DD-YYYY (o con hora MM-DD-YYYY HH:mm:ss). */

export function pad2(n) {
  return String(n).padStart(2, '0')
}

/** Hoy en MM-DD-YYYY (siempre con ceros: 07-15-2026). */
export function todayProjectDate() {
  const d = new Date()
  return `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}-${d.getFullYear()}`
}

/**
 * Normaliza a MM-DD-YYYY estricto (02 dígitos mes/día).
 * Acepta Date, ISO, MM-DD-YYYY, M-D-YYYY, slashes, etc.
 * @returns {string} '' si no se puede interpretar
 */
export function toProjectDate(value) {
  if (value == null || value === '') return ''

  // Date instance → build directly (evita String(date) ambiguo)
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${pad2(value.getMonth() + 1)}-${pad2(value.getDate())}-${value.getFullYear()}`
  }

  const raw = String(value).trim()
  const mdyPrefix = raw.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})(?:$|[ T])/)
  if (mdyPrefix) {
    return `${pad2(mdyPrefix[1])}-${pad2(mdyPrefix[2])}-${mdyPrefix[3]}`
  }
  const isoPrefix = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:$|[ T])/)
  if (isoPrefix) {
    return `${pad2(isoPrefix[2])}-${pad2(isoPrefix[3])}-${isoPrefix[1]}`
  }

  const normalized = normalizeDateToMDY(value)
  if (normalized == null || normalized === '') return ''

  const str = String(normalized).trim()
  // Validar que quedó exactamente MM-DD-YYYY
  if (/^\d{2}-\d{2}-\d{4}$/.test(str)) return str

  // Reintento explícito por si normalize dejó sin pad
  const m = str.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/)
  if (m) return `${pad2(m[1])}-${pad2(m[2])}-${m[3]}`

  const iso = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
  if (iso) return `${pad2(iso[2])}-${pad2(iso[3])}-${iso[1]}`

  return ''
}

/**
 * Fecha+hora del proyecto: MM-DD-YYYY HH:mm:ss
 */
export function toProjectDateTime(value) {
  if (value == null || value === '') return ''
  const str = String(value).trim()

  // Ya en formato proyecto con hora
  const withTime = str.match(
    /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?/
  )
  if (withTime) {
    return `${pad2(withTime[1])}-${pad2(withTime[2])}-${withTime[3]} ${pad2(withTime[4])}:${pad2(withTime[5])}:${pad2(withTime[6] || '0')}`
  }

  // Solo fecha → medianoche
  const dateOnly = toProjectDate(value)
  if (dateOnly) return `${dateOnly} 00:00:00`

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${toProjectDate(value)} ${pad2(value.getHours())}:${pad2(value.getMinutes())}:${pad2(value.getSeconds())}`
  }

  return ''
}

/** Muestra amigable. */
export function formatProjectDateDisplay(value) {
  if (value == null || value === '') return '—'
  return toProjectDate(value) || String(value)
}
